const scrollingViewfinderHero = [
    {
        selector: '[data-react="scrollingViewfinderHero"]',
        path: { filename: 'App' },
    },
];

export { scrollingViewfinderHero };
